import { ProblemIssueType } from "./problem-issue-type";


export class ProblemIssue {
    problemId : number;
    issueIds : number[] = [];
    issuse: ProblemIssueType[];
    constructor(){
      this.issuse = [];
    }
  }



